import React from 'react';

const About = () => {
    return (
        <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-poppins font-bold text-aulanovus-blue mb-8 text-center">
          Sobre Nosotros
        </h1>
  
        <div className="max-w-3xl mx-auto">
          <div className="prose prose-lg">
            <p className="text-lg text-gray-600 mb-6 font-inter">
              En Aulanovus, nos dedicamos a transformar el futuro empresarial a través de soluciones 
              innovadoras de inteligencia artificial. Nuestra misión es hacer que la IA sea accesible 
              y práctica para empresas de todos los tamaños.
            </p>
  
            <h2 className="text-2xl font-poppins font-semibold text-aulanovus-blue mt-8 mb-4">
              Nuestra Visión
            </h2>
            <p className="text-lg text-gray-600 mb-6 font-inter">
              Aspiramos a ser líderes en la democratización de la inteligencia artificial, 
              facilitando su integración en el día a día empresarial y contribuyendo al 
              crecimiento sostenible de las organizaciones.
            </p>
  
            <h2 className="text-2xl font-poppins font-semibold text-aulanovus-blue mt-8 mb-4">
              Nuestros Valores
            </h2>
            <ul className="list-disc list-inside space-y-3 text-gray-600 font-inter">
              <li>Innovación continua en soluciones tecnológicas</li>
              <li>Compromiso con la excelencia y la calidad</li>
              <li>Transparencia en nuestras operaciones</li>
              <li>Enfoque centrado en el cliente</li>
              <li>Responsabilidad social y ética en IA</li>
            </ul>
          </div>
        </div>
      </div>
    );
};

export default About;